import { useTheme } from 'styled-components';

import { parseHeadline } from '@tmh-website/services/headline.service';
import { Color } from '@tmh-website/shared/colors';
import StyledTypo, { FontStyles } from '@tmh-website/styles/typo';

import * as Styled from './HeadlineTextBlock.styles';

export interface HeadlineTextBlockProps {
  teaser?: string | null;
  headline?: string | null;
  headlineStyle?: FontStyles;
  headlineAsH1?: boolean;
  /**
   * Give the main headline element an id. Used for e.g. aria-labelledby
   */
  headlineId?: string;
  text?: string | null;
  textAlign?: 'left' | 'center' | 'right';
  textStyle?: 'copy' | 'copyBig';
  textColor: Color;

  // FIXME: This should be written in a better, more reusable way. It was meant to be only a temporary, "hotfix-like" solution.
  //   @see https://mobilityhouse.atlassian.net/browse/WEBSITE23-356?focusedCommentId=146295
  textOpacity?: number;

  extraHeader?: string;
  hasMarginAfterHeadline?: boolean;
}

const HeadlineTextBlock = ({
  teaser,
  headline,
  headlineStyle,
  headlineAsH1 = false,
  headlineId,
  text,
  textAlign,
  textStyle = 'copy',
  textColor = Color.Blue_1000_Deep,
  textOpacity,
  extraHeader,
  hasMarginAfterHeadline,
  ...props
}: HeadlineTextBlockProps) => {
  const theme = useTheme();

  if (teaser || headline || text) {
    return (
      <Styled.Container $textAlign={textAlign} {...props}>
        {teaser && (
          <StyledTypo.Typography $style='uiText' as='p' $opacity={textOpacity ?? theme.textOpacity} $color={textColor}>
            {teaser}
          </StyledTypo.Typography>
        )}
        {headline && (
          <Styled.Headline
            $style={headlineStyle ?? 'h3'}
            as={!!headlineAsH1 ? 'h1' : parseHeadline(headline).tag}
            $color={textColor}
            $hasMarginAfterHeadline={hasMarginAfterHeadline}
            id={headlineId}
            dangerouslySetInnerHTML={{ __html: parseHeadline(headline).html }}
          />
        )}
        {text && (
          <Styled.Text
            input={text}
            typographyProps={{
              $style: textStyle,
              $opacity: textOpacity ?? theme.textOpacity,
              $color: textColor,
            }}
          />
        )}
      </Styled.Container>
    );
  } else {
    return null;
  }
};

export default HeadlineTextBlock;
